import { Routes, Route } from "react-router-dom"
import GuestBanner from "../controls/GuestBanner"
import { owners_page, members_page } from "../controls/ProtectedPage"
import { ControllerContext, SelectedSettingsContext } from "../ts/Contexts"
import GuestHome from "./GuestHome"
import { useContext, useState } from "react"
import { Cookies } from "react-cookie"
import { IShowNotificationState } from "../ts/Definitions"
import Tarlings from "../assets/banner.png";
import Discord from "../assets/Discord.png";
import Tumblr from "../assets/tumblr.svg";
import { lazyWithRetry } from "../utilities/lazyLoaderUtils"

const LogOnDialog = lazyWithRetry(() => (import('../dialogs/LogOnDialog')));
const OwnerProfilesSelection = lazyWithRetry(() => (import('./OwnerProfilesSelection')));
const MembersViewer = lazyWithRetry(() => (import('./MembersViewer')));

interface Props {
    query: URLSearchParams;
    cookies: Cookies;
    showMessage: (args: IShowNotificationState) => void;
}

export default ({ query, cookies, showMessage }: Props) => {
    const [guestMode, setGuestMode] = useState(false);
    const [logonOpenState, setLogonOpenState] = useState<{
        passwordMode?: boolean,
        userNameMode?: boolean,
        registerNew?: boolean;
    } | undefined>(cookies.getAll().username || window.location.pathname.toLowerCase().includes('forcesignin') ? {} : undefined);
    const controller = useContext(ControllerContext);
    return (<div id="outer-container">

        {!logonOpenState && guestMode && (
            <div>
                <GuestBanner loginCallback={() => setLogonOpenState({})} />
                <SelectedSettingsContext.Provider value={controller.getLoggedOnUserSettings()}>
                    <Routes>
                        {(location.pathname !== owners_page && location.pathname !== members_page)
                            && <Route
                                path={location.pathname}
                                element={<GuestHome
                                    path={location.pathname}
                                    command={query.get('command')}
                                />}
                            />}
                        <Route
                            path={owners_page}
                            element={<OwnerProfilesSelection
                                ownerId={query.get('owner')}
                                key={query.get('owner')}
                            />}
                        />
                        <Route
                            path={members_page}
                            element={<MembersViewer guestMode />}
                        />
                    </Routes>
                </SelectedSettingsContext.Provider>
            </div>
        )}
        {/* Content */}
        {(logonOpenState || !guestMode) && <div className="log-screen-container">
            {/* Background Image */}
            <div className="background-image"></div>
            <div className="background-overlay"></div>
            {!logonOpenState && !guestMode && <div className="content-container">
                {/* Logo or App Title */}
                <img src={Tarlings} className="application-logo" />
                {/* Tagline */}
                <p className="tagline">Always free task based domination</p>
                {/* Buttons */}
                <div className="button-container">
                    <button className="action-button login-button" onClick={() => { setLogonOpenState({ registerNew: false }) }}>Log In</button>
                    <button className="action-button guest-button" onClick={() => { setGuestMode(true) }}>Browse as Guest</button>
                    <button className="action-button signup-button" onClick={() => setLogonOpenState({ registerNew: true })}>Sign Up</button>
                </div>


                {/* Links */}
                <div className="social-links">
                    <a href="https://discord.gg/M3NpQF7DwH" target="_blank" rel="noopener noreferrer" className="social-link"><img src={Discord} className="social-link-discord" /></a>
                    <a href="https://www.tumblr.com/tarlingsstore" target="_blank" rel="noopener noreferrer" className="social-link" style={{ top: 10 }}><img src={Tumblr} className="social-link-tumblr" /></a>
                </div>
            </div>}
            {logonOpenState && <LogOnDialog
                cookies={cookies}
                showMessage={showMessage}
                changePasswordMode={logonOpenState.passwordMode}
                changeUserName={logonOpenState.userNameMode}
                onChangeSuccess={() => setLogonOpenState(undefined)}
                onCancel={() => setLogonOpenState(undefined)}
                registerNew={logonOpenState.registerNew}
            />}
        </div>}
    </div>
    )
}